G.WorldMapQuickPanButton = function(lvlNum) {
  Phaser.Group.call(this, game);

  this.state = game.state.getCurrentState();
  this.direction = G.WorldMapQuickPanButton.Directions.Up;

  this.avatar = G.makeImage(0,-8,'avatar_m', 0, this);
  // this.avatar = G.makeExtImage(0,-8,'avatar_m','avatar_m',0,this,false,function(){
  //   this.width = this.height = 80;
  // });
  this.avatar.anchor.setTo(0.5);
  this.avatar.width = this.avatar.height = 80;
  this.pivotTween = game.add.tween(this.pivot)
    .to({y: 10}, 500, Phaser.Easing.Sinusoidal.InOut,true, 0, -1, true);
  this.add(this.avatar);
  //this.frame = G.makeImage(0, 0, "avatar_2", [0.5, 0.52] , this);
  //this.frame.position = this.avatar.position;
  this.frame = new G.Button(0,0,'avatar_2');
  this.frame.anchor.setTo(0.5, 0.52);
  this.onClick = this.frame.onClick;
  this.add(this.frame);

  this.levelTxt = new G.Text(0,
    47,
    (
      typeof lvlNum !== 'undefined' ?
        lvlNum :
        G.saveState.getLastPassedLevelNr()+1
    ).toString(),
    {
      style: 'font-white',
      fontSize: "26px",
    },
    0.5,
    100,
    100
  );
  this.add(this.levelTxt);
};

G.WorldMapQuickPanButton.prototype = Object.create(Phaser.Group.prototype);

G.WorldMapQuickPanButton.Directions = {
  Up: 1,
  Down: 2
};

G.WorldMapQuickPanButton._TextOffsets = {
  Up: {
    x: 0,
    y: 47
  },
  Down: {
    x: 0,
    y: 42
  }
};

G.WorldMapQuickPanButton.prototype.flipDirection = function(){
  if(this.direction === G.WorldMapQuickPanButton.Directions.Up){
    this.direction = G.WorldMapQuickPanButton.Directions.Down;
    this.angle = 180;
    this.avatar.angle = 180;
    this.levelTxt.angle = 180;

    this.levelTxt.x = G.WorldMapQuickPanButton._TextOffsets.Down.x;
    this.levelTxt.y = G.WorldMapQuickPanButton._TextOffsets.Down.y;
  } else {
    this.direction = G.WorldMapQuickPanButton.Directions.Up;
    this.angle = 0;
    this.avatar.angle = 0;
    this.levelTxt.angle = 0;

    this.levelTxt.x = G.WorldMapQuickPanButton._TextOffsets.Up.x;
    this.levelTxt.y = G.WorldMapQuickPanButton._TextOffsets.Up.y;
  }
};